const id_payment_commission = {
    label: {
        commission: "komisi",
        commission_total: "total komisi",
        commission_total_selected: 'total komisi yang terpilih',
        pay: 'Pemayaran Komisi',
        bank: 'rekening pembayaran'
    },

    message: {
        process: 'komisi yang akan diproses ( {{count}} ) : '
    },

    error: {
        account_bank: "Rekening pembayaran tidak boleh kosong.",
        create: "Gagal melakukan pembayaran.",
    },

    success: {
        create: "Berhasil melakukan pembayaran.",
    }
}

export default id_payment_commission;